import { useWorkforceIntegrationsStore } from "@/modules/workforce-integrations/stores/workforce-integrations-store"

async function handleLogOutEvent() {
  const store = useWorkforceIntegrationsStore()
  store.$reset()
}

export default {
  handleLogOutEvent
}
